var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIcoLeads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.23871C0 1.05078 0.963008 0.0877686 2.15094 0.0877686H13.8491C15.037 0.0877686 16 1.05078 16 2.23871V11.7104C16 12.8984 15.037 13.8614 13.8491 13.8614H2.15094C0.963009 13.8614 0 12.8984 0 11.7104V2.23871ZM2.15094 1.08777C1.51529 1.08777 1 1.60306 1 2.23871V5.2152H7.5V1.08777H2.15094ZM8.5 1.08777V5.2152H15V2.23871C15 1.60306 14.4847 1.08777 13.8491 1.08777H8.5ZM15 6.2152H8.5V9.03829H15V6.2152ZM15 10.0383H8.5V12.8614H13.8491C14.4847 12.8614 15 12.3461 15 11.7104V10.0383ZM7.5 12.8614V10.0383H1V11.7104C1 12.3461 1.51529 12.8614 2.15094 12.8614H7.5ZM1 9.03829H7.5V6.2152H1V9.03829Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcoLeads);
export default __webpack_public_path__ + "static/media/menu-ico_leads.b50402cae9ae43c7c3a91196d6494514.svg";
export { ForwardRef as ReactComponent };